/*
 * Copyright (c) RECREWT GmbH 2022.
 */

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JobGeneral } from '@data/job-general/job-general.model';
import { EntityCrudService } from '@data/entity-crud.service';

@Injectable({
  providedIn: 'root',
})
export class JobGeneralService extends EntityCrudService<JobGeneral, JobGeneral> {
  constructor() {
    const http = inject(HttpClient);

    super('jobs/general', http);
  }
}
